import { NotSetUp, useUser } from "@procurement-agents/auth";
import { canAnswer, type ScopeApi } from "@procurement-agents/scope-api";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { firstName, greeting } from "./greeting";
import { ModuleIcon } from "./icons";
import { modulesFor } from "./modules";

export function Landing({ api }: { api: ScopeApi }) {
  const user = useUser();
  const [pending, setPending] = useState<number | null>(null);
  const hasScope = !!user?.agents.includes("scope");
  useEffect(() => {
    if (!hasScope || !user) return;
    api.listRuns({ status: "waiting" }).then((page) => setPending(page.rows.filter((r) => canAnswer(user.roles, r.pending_interrupt?.type)).length)).catch(() => setPending(null));
  }, [api, hasScope, user]);
  const modules = modulesFor(user);
  if (!modules.some((m) => m.id === "scope" || m.id === "report")) return <NotSetUp />;   // an agent claim with no module behind it
  return (
    <div className="page">
      <h1>{greeting(new Date().getHours(), firstName(user))}</h1>
      <div className="tiles">
        {modules.map((m) => (
          <Link key={m.id} to={m.to} className="tile">
            <div className="tile-head"><span className="tile-icon"><ModuleIcon id={m.id} /></span><h3>{m.name}</h3></div>
            <p className="muted">{m.blurb}</p>
            {m.id === "scope" && pending !== null && <p className="pending">{pending === 0 ? "Nothing waiting for you" : `${pending} waiting for you`}</p>}
          </Link>
        ))}
      </div>
    </div>
  );
}
